import React, { Component } from "react";
import { getToken } from "utils/storage";
import { Input, Button, Upload, message } from "antd";
import Request from "../../../../networkReq/request";
import Http from "../../../../networkReq/http";
import uploadIcon from "../../../../img/userCenter/icon_upload_img.png";
import cancelIcon from "../../../../img/userCenter/icon_cancel.png";
import { formConfig } from "./fieldConfig";
import { RenderForm, RenderFormItem, EchoForm } from "./components";
import Nav from "components/Nav";
import { navRouter } from "../fieldConfig";
import "./index.scss";

function beforeUpload(file) {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isJpgOrPng) {
    message.error("只能上传图片(图片格式为jpg或png)！");
  } else if (!isLt2M) {
    message.error("图片不能超过2MB!");
  }
  //   return isJpgOrPng && isLt2M;
  return new Promise(async (resolve, reject) => {
    if (isJpgOrPng && isLt2M) {
      return resolve(true);
    }
    return reject(false); //加上这个就会阻止默认上传
  });
}

const uploadProps = {
  name: "file",
  showFileList: false,
  className: "avatar-uploader",
  showUploadList: false,
  headers: {
    Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
    "Blade-Auth": getToken(),
  },
  action: "/tyjrmh/api/blade-file/fileServer/uploadSingle",
  beforeUpload: beforeUpload,
};

export default class UserInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      resData: {},
      formConfig: formConfig(),
      formConfig1: formConfig(),
      materiList: [],
      materiList1: [],
      auditMechanismState: "", //审核状态（0提交 1通过 2未通过 3草稿）
      isInfoEdit: false,
      isMateriUpload: false,
      areaInfo: {},
    };
  }
  componentWillMount() {
    const token = getToken();
    if (token) {
      this.setState({
        token: token,
      });
    }

    this.getInstitutionInfo();
  }

  getInstitutionInfo() {
    let userId = localStorage.getItem("userId");
    let params = { userId };
    Http.get(Request.institutionInfo1(), params, (obj) => {
      if (obj.code == 200) {
        this.setState({
          resData: obj.data,
          formConfig: formConfig(obj.data),
          formConfig1: formConfig(obj.data),
          materiList: [...obj.data.sybPhotoManages],
          materiList1: [...obj.data.sybPhotoManages],
          auditMechanismState: obj.data.auditMechanismState,
        });
      } else {
        // Message.error("登录信息已失效，请重新登录");
        // setTimeout(() => {
        //     this.props.history.push('/login')
        // }, 1000);
      }
    });
  }

  handleChange(value, name) {
    const { formConfig1 } = this.state;
    // console.log("------handleChange------", name, value);
    formConfig1.forEach((item) => {
      if (item.name == name) {
        item.value = value;
      }
    });
    this.setState({ formConfig1 }, () => {
      // console.log("formConfig1", formConfig1);
    });
  }
  handleChange2(value) {
    // console.log("value", value);
    this.setState({ areaInfo: value });
  }

  handleSubmit(e) {
    e.preventDefault();
  }

  handleCancel(type) {
    // console.log("------handleCancel------", type);
    const { formConfig, materiList } = this.state;
    // if (type == 'form') {
    //     this.setState({ isInfoEdit: false, formConfig1: [...formConfig] });
    // } else if (type == 'upload') {
    //     this.setState({ isMateriUpload: false, materiList1: [...materiList] });
    // }
    this.setState({
      isInfoEdit: false,
      formConfig1: [...formConfig],
      materiList1: [...materiList],
    });
  }

  handleSave(type) {
    // console.log("------handleSave------");
    const { formConfig1, materiList1, resData } = this.state;
    // 校验
    let curLabel = "";
    formConfig1.forEach((item) => {
      if (item.name == "email" && !item.pattern.test(item.value)) {
        curLabel = "企业邮箱格式不正确！";
      }
      if (item.name == "phone" && !item.pattern.test(item.value)) {
        curLabel = "电话号码格式不正确！";
      }
      if (item.name == "auditMechanismCode" && !item.pattern.test(item.value)) {
        curLabel = "统一社会信用代码格式不正确！";
      }
      if (item.type == "text" && item.value.length > item.max) {
        curLabel = `${item.label}限制${item.max}字！`;
      }
      if (item.require && !item.value) {
        curLabel = `请输入${item.label}`;
      }
    });
    if (curLabel) {
      message.error(curLabel);
      return;
    }
    if (materiList1.length == 0) {
      message.error(`请上传企业营业执照`);
      return;
    }

    if (type == "form") {
      this.setState({ isInfoEdit: false, formConfig: [...formConfig1] });
    } else if (type == "upload") {
      this.setState({ isMateriUpload: false, materiList: [...materiList1] });
    }

    if (resData.auditMechanismState === 0) {
      this.updateInstitutionInfo();
    } else {
      this.authInstitutionInfo();
    }
  }

  authInstitutionInfo() {
    const { resData } = this.state;
    let userId = localStorage.getItem("userId");
    let formatData = this.formatData();
    // console.log("length", formatData.auditMechanismLocation.split(",").length);

    if (formatData.auditMechanismLocation.split(",").length != 3) {
      message.error("地区选择必须精确到县级");
      return;
    }
    const params = {
      ...formatData,
      userId,
      auditMechanismState: resData.auditMechanismState,
    };
    Http.post(Request.institutionInfoAuth(), params, (obj) => {
      // console.log("------institutionInfoAuth------", obj);
      if (obj.code == 200) {
        message.success(obj.msg);
        this.getInstitutionInfo();
      } else {
        message.error(obj.msg);
        // setTimeout(() => {
        //     this.props.history.push('/login')
        // }, 1000);
      }
      this.setState({ isInfoEdit: false });
    });
    // console.log("------institutionInfoAuth------", params);
  }

  updateInstitutionInfo() {
    const { resData } = this.state;
    let userId = localStorage.getItem("userId");
    let formatData = this.formatData();
    // console.log("length", formatData.auditMechanismLocation.split(",").length);

    if (formatData.auditMechanismLocation.split(",").length != 3) {
      message.error("地区选择必须精确到县级");
      return;
    }
    const params = {
      ...formatData,
      userId,
      id: resData.id,
      auditMechanismState: resData.auditMechanismState,
    };
    Http.post(Request.institutionInfoUpdate(), params, (obj) => {
      // console.log("------institutionInfoUpdate------", obj);
      if (obj.code == 200) {
        message.success(obj.msg);
        this.getInstitutionInfo();
        // this.setState({
        // });
      } else {
        message.error(obj.msg);
        // setTimeout(() => {
        //     this.props.history.push('/login')
        // }, 1000);
      }
      this.setState({ isInfoEdit: false });
    });
    // console.log("------institutionInfoUpdate------", params);
  }

  //收集表单数据
  formatData() {
    const { formConfig1, materiList1, areaInfo } = this.state;
    let obj = {};
    formConfig1.forEach((item) => (obj[item.name] = item.value));
    obj.sybPhotoManages = materiList1;
    switch (obj.auditMechanismType) {
      case "招聘企业":
        obj.auditMechanismType = 0;
        break;
      case "培训机构":
        obj.auditMechanismType = 1;
        break;
      case "金融机构":
        obj.auditMechanismType = 2;
        break;
      default:
        break;
    }
    // console.log("areaInfo2", areaInfo);
    if (areaInfo.countyId) {
      //     message.error('地区选择必须精确到县级')
      //     return
      // }else{
      // console.log("areaInfo", areaInfo);
      let v = "";
      if (areaInfo.countyId) {
        v = `${areaInfo.provinceId},${areaInfo.cityId},${areaInfo.countyId}`;
      } else if (areaInfo.cityId) {
        v = `${areaInfo.provinceId},${areaInfo.cityId}`;
      } else if (areaInfo.provinceId) {
        v = `${areaInfo.provinceId}`;
      }
      obj.orgId = v;
    }
    console.log("------formatData------", obj);
    return obj;
  }

  // handleVerify(type) {
  //     console.log("------handleVerify------");
  //     this.setState({ isMateriUpload: false });

  // }

  delImg(index) {
    const { materiList1 } = this.state;
    console.log("delImg", index);
    materiList1.splice(index, 1);
    this.setState({ materiList1 });
  }

  handleUploadChange = (info) => {
    const { materiList1 } = this.state;
    if (info.file.status !== "uploading") {
      console.log(info.file, info.fileList);
    }

    if (info.file.status === "done") {
      let photoUrl = info.file.response.data.url;
      materiList1.push({ photoUrl });
      this.setState({ materiList1 });
      // getBase64(info.file.originFileObj, (url) => {
      //   this.setState({ loading: false, imageUrl: url })
      // });
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  authStatus = () => {
    const { auditMechanismState } = this.state;
    let arr = ["认证中", "认证通过", "未通过认证"];
    return arr[auditMechanismState];
  };

  render() {
    const { history } = this.props;
    const {
      materiList1,
      formConfig1,
      isInfoEdit,
      isMateriUpload,
      auditMechanismState,
    } = this.state;

    return (
      <div className="enterprise_info">
        <div className="left_nav">
          <Nav defaultActive={"1"} history={history} dataList={navRouter} />
        </div>
        <div className="right_cont">
          <div className={isInfoEdit ? "info_edit" : ""}>
            <div
              className={["base_info", isInfoEdit ? "" : "base_info_edit"].join(
                " "
              )}
            >
              <div className="base_info_title">基本信息</div>
              {isInfoEdit ? (
                <RenderForm
                  dataList={formConfig1}
                  onChange={this.handleChange.bind(this)}
                  onChange2={this.handleChange2.bind(this)}
                  handleCancel={this.handleCancel.bind(this, "form")}
                  handleSave={this.handleSave.bind(this, "form")}
                >
                  {(props) => <RenderFormItem {...props} />}
                </RenderForm>
              ) : (
                <EchoForm dataList={formConfig1} />
              )}
              <div
                className="edit_info_btn"
                onClick={() => this.setState({ isInfoEdit: true })}
              >
                修改信息
              </div>
            </div>
            <div
              className={[
                "cert_materi",
                isInfoEdit ? "cert_materi_edit" : "",
              ].join(" ")}
            >
              <div className="cert_title">企业营业执照（图片）</div>
              <div className="sub_title">
                (请上传大小不超过2M的jpg或png格式的图片)
              </div>
              <div
                className={[
                  "materi_list",
                  isInfoEdit ? "materi_list_upload" : "",
                ].join(" ")}
              >
                {materiList1.length > 0 &&
                  materiList1.map((item, index) => {
                    return (
                      <div className="item_img" key={Math.random()}>
                        <img
                          src={item.photoUrl}
                          alt=""
                          style={{ cursor: "pointer" }}
                        />
                        <span
                          className="del_img_btn"
                          onClick={() => this.delImg(index)}
                        >
                          <img src={cancelIcon} alt="" />
                        </span>
                      </div>
                    );
                  })}
                {materiList1.length <= 3 && isInfoEdit && (
                  <Upload {...uploadProps} onChange={this.handleUploadChange}>
                    <div
                      className="upload_materi"
                      style={{ cursor: "pointer" }}
                    >
                      <div className="upload_img">
                        <img src={uploadIcon} alt="" />
                        <span className="">点击上传</span>
                      </div>
                    </div>
                  </Upload>
                )}
              </div>
              {/* <div className="upload_materi_btn">
                                <Button
                                    size="small"
                                    type="primary"
                                    className="upload_btn"
                                    onClick={() => this.setState({ isInfoEdit: true })}
                                >
                                    上传材料
                                </Button>
                            </div> */}
              {isInfoEdit && (
                <div className="cancel_verify">
                  <button
                    style={{ cursor: "pointer" }}
                    className="cancel_btn"
                    onClick={this.handleCancel.bind(this, "upload")}
                  >
                    取消
                  </button>
                  <button
                    style={{ cursor: "pointer" }}
                    className="verify_btn"
                    onClick={this.handleSave.bind(this, "upload")}
                  >
                    提交
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="cert_results">
            <div className="base_info_title">认证结果</div>
            {auditMechanismState !== "" ? (
              <div
                className={
                  [
                    "result_content_pending",
                    "result_content_success",
                    "result_content_failed",
                  ][auditMechanismState]
                }
              >
                {this.authStatus()}
              </div>
            ) : (
              <div className="unload_materi">还未上传认证材料！</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
